module.exports = function () {
  var $ = require('boxjs/dist/utils/_bdboxWrapper');
  /* eslint-disable */

  /**
   * 获取框的版本号
   * @memberOf Bdbox.utils
   * @name getMissionVersion
   * @function
   * @return {String} version 返回框的版本号
   * @author renzhonghua
   */


  return function () {
    var back = 0;

    if ($.isMissionBox) {
      var a = /baiduboxapp\/([\d+.]+)/.exec(navigator.userAgent);
      back = a[1];
    }

    return back;
  };
}();